import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'keys',
})
export class ObjectKeysPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public transform(value, args?: string[]): any {
    const keys = [];
    for (const key in value) {
      /* istanbul ignore else */
      // eslint-disable-next-line no-prototype-builtins
      if (value.hasOwnProperty(key)) {
        keys.push({ key: key, value: value[key] });
      }
    }
    return keys;
  }
}
